import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import LoginPage from '@/pages/login/page';
import AppLayout from '@/components/feature/AppLayout';
import ProtectedRoute from '@/components/feature/ProtectedRoute';
import DashboardPage from '@/pages/dashboard/page';
import ProjectsPage from '@/pages/projects/page';
import NewProjectPage from '@/pages/projects/new/page';
import EditProjectPage from '@/pages/projects/edit/page';
import ProjectDetailPage from '@/pages/projects/detail/page';
import BillingPage from '@/pages/billing/page';
import FinancePage from '@/pages/finance/page';
import SettingsPage from '@/pages/settings/page';
import UsersPage from '@/pages/users/page';

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'proyectos', element: <ProjectsPage /> },
      { path: 'proyectos/nuevo', element: <NewProjectPage /> },
      { path: 'proyectos/:id/editar', element: <EditProjectPage /> },
      { path: 'proyectos/:id', element: <ProjectDetailPage /> },
      { path: 'facturacion', element: <BillingPage /> },
      { path: 'finanzas', element: <FinancePage /> },
      {
        path: 'usuarios',
        element: (
          <ProtectedRoute requireSuper>
            <UsersPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'configuracion',
        element: (
          <ProtectedRoute requireSuper>
            <SettingsPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;